import MessagingAddApp from 'components/settings/containers/sections/messaging/messagingAddApp';
export const SettingsMessagingFacebookSetupView = MessagingAddApp;
